module.exports = __webpack_public_path__ + "img/PL09425.d842fb01.png";